import React from 'react'
import { Link } from 'react-router-dom'

function Intro() {
  return (
    <section className="flex flex-col md:flex-row lg:mx-16 my-5">
    <div className="w-full md:w-[60%] flex flex-col items-center md:mr-12 lg:mx-[7%] lg:py-10">
     <h1 className="bg-gradient-to-r from-white via-enhancedTeal to-purpleCustom 
     inline-block text-transparent bg-clip-text text-[28px] md:text-2xl lg:text-5xl font-bold ">
       Your journey to a better democracy starts here.
     </h1>
     <p className="lg:text-xl mt-5 md:pr-5 font-nunito font-medium text-white indent-4">
     At OpenPolitica, we are a one stop shop for all your democratic needs. We understand the value of 
     sharing a common goal and offer options for you to discuss your thoughts with users and professionals 
     from all around the world. 
     </p>
    </div>



    <div className="mt-10 md:mt-0 w-full md:w-[40%] flex flex-col ">
      <div className="text-center">
       <h2 className="lg:text-2xl font-nunito font-bold text-white md:mb-8">
       Sign up today and find out how we make your voices matter.
       </h2>
       <Link
         to="/signin"
         className="bg-gradient-to-r from-[#284B63] via-enhancedTeal to-greenOnDarkMode flex justify-center items-center h-[300px] md:h-[150px] lg:h-[200px] w-full my-5
         text-center rounded-md font-bold text-xl text-white font-nunito"
       >
        Click here to Join
       </Link>

      </div>
    </div>

 </section>
  )
}

export default Intro
